<template>
  <b-form-group>
    <b-form-file
      v-model="file1"
      :placeholder="placeholder"
      accept="image/*, audio/mp3, video/mp4"
      @change="fileSelect($event)"
      drop-placeholder="Drop file   here..."
    ></b-form-file>
    <div class="file-result" v-if="imgsrc != null">
      <img :src="imgsrc" class="preview" v-if="fileobj == 'image'" />
      <b-button size="sm" variant="danger" @click="del()">삭제</b-button>
    </div>
  </b-form-group>
</template>

<script>
import Vue from "vue";

export default {
  props: ["fileobj", "utype"],
  data() {
    return {
      imgsrc: null,
      file1: null,
      bucket: "com.cedu.csd",
      region: "ap-northeast-2",
      poolId: "ap-northeast-2:dc9b0c57-3ee5-47da-9239-931dcf6da667",
    };
  },
  mounted() {},
  computed: {
    placeholder() {
      if (this.utype === "image") {
        return "이미지";
      } else if (this.utype === "sound") {
        return "음원";
      } else {
        return "기본";
      }
    },
  },
  methods: {
    fileSelect(evt) {
      let file = event.target.files[0];
      let myContentType = "image/png";
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imgsrc = reader.result;
      };

      if(this.utype === "sound"){
        myContentType = "audio/mpeg"
      }
      
      this.$S3.upload(
        {
          Key: file.name,
          ContentType: myContentType,
          Body: file,

          ACL: "public-read",
        },
        (err, data) => {
          if (err) {
            console.log(err);
            return alert("error");
          } else {
            Vue.set(
              this.$store.state.questionform,
              this.fileobj,
              data.Location
            );
          }
        }
      );
    },
    del() {
      this.imgsrc = null;
      this.file1 = null;
      Vue.set(this.$store.state.questionform, this.fileobj, "");
    },
  },
};
</script>


<style lang="scss" scoped>
.file-result {
  display: flex;
  align-items: flex-end;

  .preview {
    max-height: 100px;
  }
}
</style>